import { useContext } from 'react';
import { AppProviderContext } from '../providers/AppProvider';

export const useLoading = () => {
  const { loading, setLoading, localLoading, setLocalLoading, globalLoading, setGlobalLoading } = useContext(
    AppProviderContext,
  );
  return { loading, setLoading, localLoading, setLocalLoading, globalLoading, setGlobalLoading };
};
